import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DeletereminderPage } from './deletereminder';

@NgModule({
  declarations: [
    DeletereminderPage,
  ],
  imports: [
    IonicPageModule.forChild(DeletereminderPage),
  ],
})
export class DeletereminderPageModule {}



// WEBPACK FOOTER //
// ./src/pages/deletereminder/deletereminder.module.ts